"use strict";
// import {
//   CustomOrderLine,
//   ExcursionOrderLine,
//   GolfOrderLine,
//   HotelOrderLine,
//   TransferOrderLine,
// } from "../../models";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineConfigWarnings = void 0;
const getOrderLineConfigWarnings = (data, type) => {
    if (!data || !type)
        return null;
    switch (type) {
        case "GOLF": {
            // const config = data as unknown as GolfOrderLine;
            return null;
        }
        case "HOTEL": {
            // const config = data as unknown as HotelOrderLine;
            return null;
        }
        case "EXCURSION": {
            // const config = data as unknown as ExcursionOrderLine;
            return null;
        }
        case "TRANSFER": {
            // const config = data as unknown as TransferOrderLine;
            return null;
        }
        case "CUSTOM": {
            // const config = data as unknown as CustomOrderLine;
            return null;
        }
    }
};
exports.getOrderLineConfigWarnings = getOrderLineConfigWarnings;
